import { render, staticRenderFns } from "./NZTreatmentHistory.vue?vue&type=template&id=16bccbae&scoped=true&"
import script from "./NZTreatmentHistory.vue?vue&type=script&lang=js&"
export * from "./NZTreatmentHistory.vue?vue&type=script&lang=js&"
import style0 from "./NZTreatmentHistory.vue?vue&type=style&index=0&id=16bccbae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bccbae",
  null
  
)

export default component.exports